module.exports = __webpack_public_path__ + "static/img/Hex_2.b5aa99a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Mobile/Mobile_Landing/Hex_2.png
// module id = zBs1
// module chunks = 0